module.exports = __webpack_public_path__ + "img/attachment.fba16150.svg";